import API from '@apis/client';
import { AxiosResponse } from 'axios';
import { getSaleDetailPayload, getSaleItemPayload, getSalePayload } from 'models/Supplement';
import {
  QuotationGetSaleDetailData,
  QuotationGetSaleDetailError,
  QuotationGetSaleListData,
  QuotationGetSaleListError,
  QuotationSaleGetSaleItemData,
  QuotationSaleGetSaleItemError,
} from 'models/swagger/data-contracts';

/**
 *  판매중인 프로젝트 리스트 가져오기 API
 *  @function getSaleApi
 *  @param {number} page 페이지
 *  @param {boolean} finish 완료 여부
 *  @param {string} product_type product_type
 */
export const getSaleApi = ({
  page,
  finish,
  product_type,
}: getSalePayload): Promise<AxiosResponse<QuotationGetSaleListData, QuotationGetSaleListError>> => {
  return API.get(`/quotation/sale?page=${page}&finish=${finish}&product_type=${product_type}`);
};

/**
 *  판매 프로젝트 상세 조회 API
 *  @function getSaleDetailApi
 *  @param {number} rfq_number_id rfq number id
 */
export const getSaleDetailApi = ({
  rfq_number_id,
}: getSaleDetailPayload): Promise<AxiosResponse<QuotationGetSaleDetailData, QuotationGetSaleDetailError>> => {
  return API.get(`/quotation/sale/${rfq_number_id}`);
};

/**
 *  판매 프로젝트 아이템 리스트 조회 API
 *  @function getSaleItemApi
 *  @param {number} rfq_number_id rfq number id
 */
export const getSaleItemApi = ({
  rfq_number_id,
}: getSaleItemPayload): Promise<AxiosResponse<QuotationSaleGetSaleItemData, QuotationSaleGetSaleItemError>> => {
  return API.get(`/quotation/sale/${rfq_number_id}/item`);
};
